
/**
 * Featherlight - ultra slim jQuery lightbox
 * Version 1.7.14 - http://noelboss.github.io/featherlight/
 *
 * Copyright 2019, Noël Raoul Bossart (http://www.noelboss.com)
 * MIT Licensed.
**/
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof module&&module.exports?module.exports=function(b,c){return void 0===c&&(c="undefined"!=typeof window?require("jquery"):require("jquery")(b)),a(c),c}:a(jQuery)}(function(a){"use strict";function b(a,c){if(!(this instanceof b)){var d=new b(a,c);return d.open(),d}this.id=b.id++,this.setup(a,c),this.chainCallbacks(b._callbackChain)}function c(a,b){var c={};for(var d in a)d in b&&(c[d]=a[d],delete a[d]);return c}function d(a,b){var c={},d=new RegExp("^"+b+"([A-Z])(.*)");for(var e in a){var f=e.match(d);if(f){var g=(f[1]+f[2].replace(/([A-Z])/g,"-$1")).toLowerCase();c[g]=a[e]}}return c}if("undefined"==typeof a)return void("console"in window&&window.console.info("Too much lightness, Featherlight needs jQuery."));if(a.fn.jquery.match(/-ajax/))return void("console"in window&&window.console.info("Featherlight needs regular jQuery, not the slim version."));var e=[],f=function(b){return e=a.grep(e,function(a){return a!==b&&a.$instance.closest("body").length>0})},g={allow:1,allowfullscreen:1,frameborder:1,height:1,longdesc:1,marginheight:1,marginwidth:1,mozallowfullscreen:1,name:1,referrerpolicy:1,sandbox:1,scrolling:1,src:1,srcdoc:1,style:1,webkitallowfullscreen:1,width:1},h={keyup:"onKeyUp",resize:"onResize"},i=function(c){a.each(b.opened().reverse(),function(){return c.isDefaultPrevented()||!1!==this[h[c.type]](c)?void 0:(c.preventDefault(),c.stopPropagation(),!1)})},j=function(c){if(c!==b._globalHandlerInstalled){b._globalHandlerInstalled=c;var d=a.map(h,function(a,c){return c+"."+b.prototype.namespace}).join(" ");a(window)[c?"on":"off"](d,i)}};b.prototype={constructor:b,namespace:"featherlight",targetAttr:"data-featherlight",variant:null,resetCss:!1,background:null,openTrigger:"click",closeTrigger:"click",filter:null,root:"body",openSpeed:250,closeSpeed:250,closeOnClick:"background",closeOnEsc:!0,closeIcon:"&#10005;",loading:"",persist:!1,otherClose:null,beforeOpen:a.noop,beforeContent:a.noop,beforeClose:a.noop,afterOpen:a.noop,afterContent:a.noop,afterClose:a.noop,onKeyUp:a.noop,onResize:a.noop,type:null,contentFilters:["jquery","image","html","ajax","iframe","text"],setup:function(b,c){"object"!=typeof b||b instanceof a!=!1||c||(c=b,b=void 0);var d=a.extend(this,c,{target:b}),e=d.resetCss?d.namespace+"-reset":d.namespace,f=a(d.background||['<div class="'+e+"-loading "+e+'">','<div class="'+e+'-content">','<button class="'+e+"-close-icon "+d.namespace+'-close" aria-label="Close">',d.closeIcon,"</button>",'<div class="'+d.namespace+'-inner">'+d.loading+"</div>","</div>","</div>"].join("")),g="."+d.namespace+"-close"+(d.otherClose?","+d.otherClose:"");return d.$instance=f.clone().addClass(d.variant),d.$instance.on(d.closeTrigger+"."+d.namespace,function(b){if(!b.isDefaultPrevented()){var c=a(b.target);("background"===d.closeOnClick&&c.is("."+d.namespace)||"anywhere"===d.closeOnClick||c.closest(g).length)&&(d.close(b),b.preventDefault())}}),this},getContent:function(){if(this.persist!==!1&&this.$content)return this.$content;var b=this,c=this.constructor.contentFilters,d=function(a){return b.$currentTarget&&b.$currentTarget.attr(a)},e=d(b.targetAttr),f=b.target||e||"",g=c[b.type];if(!g&&f in c&&(g=c[f],f=b.target&&e),f=f||d("href")||"",!g)for(var h in c)b[h]&&(g=c[h],f=b[h]);if(!g){var i=f;if(f=null,a.each(b.contentFilters,function(){return g=c[this],g.test&&(f=g.test(i)),!f&&g.regex&&i.match&&i.match(g.regex)&&(f=i),!f}),!f)return"console"in window&&window.console.error("Featherlight: no content filter found "+(i?' for "'+i+'"':" (no target specified)")),!1}return g.process.call(b,f)},setContent:function(b){return this.$instance.removeClass(this.namespace+"-loading"),this.$instance.toggleClass(this.namespace+"-iframe",b.is("iframe")),this.$instance.find("."+this.namespace+"-inner").not(b).slice(1).remove().end().replaceWith(a.contains(this.$instance[0],b[0])?"":b),this.$content=b.addClass(this.namespace+"-inner"),this},open:function(b){var c=this;if(c.$instance.hide().appendTo(c.root),!(b&&b.isDefaultPrevented()||c.beforeOpen(b)===!1)){b&&b.preventDefault();var d=c.getContent();if(d)return e.push(c),j(!0),c.$instance.fadeIn(c.openSpeed),c.beforeContent(b),a.when(d).always(function(a){a&&(c.setContent(a),c.afterContent(b))}).then(c.$instance.promise()).done(function(){c.afterOpen(b)})}return c.$instance.detach(),a.Deferred().reject().promise()},close:function(b){var c=this,d=a.Deferred();return c.beforeClose(b)===!1?d.reject():(0===f(c).length&&j(!1),c.$instance.fadeOut(c.closeSpeed,function(){c.$instance.detach(),c.afterClose(b),d.resolve()})),d.promise()},resize:function(a,b){if(a&&b){this.$content.css("width","").css("height","");var c=Math.max(a/(this.$content.parent().width()-1),b/(this.$content.parent().height()-1));c>1&&(c=b/Math.floor(b/c),this.$content.css("width",""+a/c+"px").css("height",""+b/c+"px"))}},chainCallbacks:function(b){for(var c in b)this[c]=a.proxy(b[c],this,a.proxy(this[c],this))}},a.extend(b,{id:0,autoBind:"[data-featherlight]",defaults:b.prototype,contentFilters:{jquery:{regex:/^[#.]\w/,test:function(b){return b instanceof a&&b},process:function(b){return this.persist!==!1?a(b):a(b).clone(!0)}},image:{regex:/\.(png|jpg|jpeg|gif|tiff?|bmp|svg)(\?\S*)?$/i,process:function(b){var c=this,d=a.Deferred(),e=new Image,f=a('<img src="'+b+'" alt="" class="'+c.namespace+'-image" />');return e.onload=function(){f.naturalWidth=e.width,f.naturalHeight=e.height,d.resolve(f)},e.onerror=function(){d.reject(f)},e.src=b,d.promise()}},html:{regex:/^\s*<[\w!][^<]*>/,process:function(b){return a(b)}},ajax:{regex:/./,process:function(b){var c=a.Deferred(),d=a("<div></div>").load(b,function(a,b){"error"!==b&&c.resolve(d.contents()),c.reject()});return c.promise()}},iframe:{process:function(b){var e=new a.Deferred,f=a("<iframe/>"),h=d(this,"iframe"),i=c(h,g);return f.hide().attr("src",b).attr(i).css(h).on("load",function(){e.resolve(f.show())}).appendTo(this.$instance.find("."+this.namespace+"-content")),e.promise()}},text:{process:function(b){return a("<div>",{text:b})}}},functionAttributes:["beforeOpen","afterOpen","beforeContent","afterContent","beforeClose","afterClose"],readElementConfig:function(b,c){var d=this,e=new RegExp("^data-"+c+"-(.*)"),f={};return b&&b.attributes&&a.each(b.attributes,function(){var b=this.name.match(e);if(b){var c=this.value,g=a.camelCase(b[1]);if(a.inArray(g,d.functionAttributes)>=0)c=new Function(c);else try{c=JSON.parse(c)}catch(h){}f[g]=c}}),f},extend:function(b,c){var d=function(){this.constructor=b};return d.prototype=this.prototype,b.prototype=new d,b.__super__=this.prototype,a.extend(b,this,c),b.defaults=b.prototype,b},attach:function(b,c,d){var e=this;"object"!=typeof c||c instanceof a!=!1||d||(d=c,c=void 0),d=a.extend({},d);var f,g=d.namespace||e.defaults.namespace,h=a.extend({},e.defaults,e.readElementConfig(b[0],g),d),i=function(g){var i=a(g.currentTarget),j=a.extend({$source:b,$currentTarget:i},e.readElementConfig(b[0],h.namespace),e.readElementConfig(g.currentTarget,h.namespace),d),k=f||i.data("featherlight-persisted")||new e(c,j);"shared"===k.persist?f=k:k.persist!==!1&&i.data("featherlight-persisted",k),j.$currentTarget.blur&&j.$currentTarget.blur(),k.open(g)};return b.on(h.openTrigger+"."+h.namespace,h.filter,i),{filter:h.filter,handler:i}},current:function(){var a=this.opened();return a[a.length-1]||null},opened:function(){var b=this;return f(),a.grep(e,function(a){return a instanceof b})},close:function(a){var b=this.current();return b?b.close(a):void 0},_onReady:function(){var b=this;if(b.autoBind){var c=a(b.autoBind);c.each(function(){b.attach(a(this))}),a(document).on("click",b.autoBind,function(d){if(!d.isDefaultPrevented()){var e=a(d.currentTarget),f=c.length;if(c=c.add(e),f!==c.length){var g=b.attach(e);(!g.filter||a(d.target).parentsUntil(e,g.filter).length>0)&&g.handler(d)}}})}},_callbackChain:{onKeyUp:function(b,c){return 27===c.keyCode?(this.closeOnEsc&&a.featherlight.close(c),!1):b(c)},beforeOpen:function(b,c){return a(document.documentElement).addClass("with-featherlight"),this._previouslyActive=document.activeElement,this._$previouslyTabbable=a("a, input, select, textarea, iframe, button, iframe, [contentEditable=true]").not("[tabindex]").not(this.$instance.find("button")),this._$previouslyWithTabIndex=a("[tabindex]").not('[tabindex="-1"]'),this._previousWithTabIndices=this._$previouslyWithTabIndex.map(function(b,c){return a(c).attr("tabindex")}),this._$previouslyWithTabIndex.add(this._$previouslyTabbable).attr("tabindex",-1),document.activeElement.blur&&document.activeElement.blur(),b(c)},afterClose:function(c,d){var e=c(d),f=this;return this._$previouslyTabbable.removeAttr("tabindex"),this._$previouslyWithTabIndex.each(function(b,c){a(c).attr("tabindex",f._previousWithTabIndices[b])}),this._previouslyActive.focus(),0===b.opened().length&&a(document.documentElement).removeClass("with-featherlight"),e},onResize:function(a,b){return this.resize(this.$content.naturalWidth,this.$content.naturalHeight),a(b)},afterContent:function(a,b){var c=a(b);return this.$instance.find("[autofocus]:not([disabled])").focus(),this.onResize(b),c}}}),a.featherlight=b,a.fn.featherlight=function(a,c){return b.attach(this,a,c),this},a(document).ready(function(){b._onReady()})});



// PDP Color Image Filter
function updateImageColor() {

    // NavyBlue
    // RoyalPurple
    // HotPink
    // SailBlue
    // HeatherGrey
    // Tan

    var a = $(".color :checked").val();
    // console.log("a:" + a);

    $(".product-gallery--image-thumbnail").hide();

    if (a == "Gray" || a == "Grey" || a == "Heather Gray" || a == "Heather Grey") {
        var b = "HeatherGrey"
    } else if (a == "Purple" || a == "Royal Purple") {
        var b = "RoyalPurple"
    } else if (a == "Pink" || a == "Hot Pink") {
        var b = "HotPink"
    } else if (a == "Navy" || a == "Navy Blue") {
        var b = "NavyBlue"
    } else if (a == "Blue" || a == "Sail Blue") {
        var b = "SailBlue"
    } else if (a == "Shimmering Sand") {
      var b = "ShimmeringSand";
    }

    // console.log("b:" + b);

    $(".product-gallery--image-thumbnail img[src*='" + b + "']").parent(".product-gallery--image-thumbnail").show();
    $(".product-gallery--navigation button:visible:first").click();

}


$(document).ready(function(){
  // Handle offsetting the fixed sticky header when clicking on anchor links
  $('a[href^=#]').on('click', function(e){
    var href = $(this).attr('href');
    var headerHeight = $('.main-header-wrapper').outerHeight() + $('.mega-header').outerHeight();

    $('html, body').animate({
        scrollTop: $(href).offset().top - headerHeight + "px"
    },1000);
    e.preventDefault();
  });
  
//if on a safety sleeper
if ($("body").hasClass("the-safety-sleeper")) {

    //refresh affirm financing whenever something changes the price 
    $('.the-price').bind('DOMSubtreeModified', function(e) {
        if (e.target.innerHTML.length > 0) {

            var a = $('.the-price').text().replace("$", "").replace(",", "");
            a = parseFloat(a) * 100;

            // refresh arrirm
            if (a > 0) {
                //console.log('refreshing affirm');
                $('.affirm-as-low-as').attr('data-amount', a);
                if ( typeof affirm !== 'undefined' ) {
                  affirm.ui.refresh();
                }
            }
            //update list price based on current options

        }
    });





    // PDP dimensions

    //define mattress size dimensions
    var twin = '37" x 74.5" x 44"';
    var twinxl = '37" x 79.5" x 44"';
    var full = '52" x 74.5" x 44"';
    var queen = '58" x 80" x 44"';


    function updateDimensions() {

        var a = $(".size input:checked").val();
        var b = '';
        if (a == "Twin") {
            b = twin;
        } else if (a == "Twin XL") {
            b = twinxl;
        } else if (a == "Full") {
            b = full;
        } else if (a == "Queen") {
            b = queen;
        }

      $('#sizeDetails').html('&mdash; ' + b);
      
      //tech specs selector
      $("a.tab-selector").click(function() {
        var a = $(this).attr("data-tab-select");
        $(".prodtabs [value='"+a+"']+label").click();
      });
    }

    //run on init 
    $(document).ready(function() {
      $(".the-safety-sleeper .inline-field-wrapper.size").append("<div id='dimensions'></div>");
         updateDimensions();
      });

      // run on size selection change 
      $(".the-safety-sleeper .size input").change(function() {
          updateDimensions();
      });


    

    //run on init 
    updateImageColor();


    $(".color input").change(function() {
        updateImageColor();
    });

  function setupUpgrades() {
    $('.bold_option').each(function(){
      var $option = $(this);
      var $inputContainer = $option.find('.bold_option_element');      
      var $label = $(this).find('label');
      var $price = $(this).find('.bold_option_value_price');
      var $helpText = $option.find('.bold_help_text');
      var imageSrc = $helpText.find('img').attr('src');

      $helpText.appendTo($label);
      $price.insertAfter($helpText);

      $tooltip = $('<a class="more-info-icon" href="'+imageSrc+'">i</a>').prependTo($label);

      $('.more-info-icon').each(function(){
        $(this).magnificPopup({
          type: 'image',
          mainClass: 'mfp-with-zoom',
          closeOnContentClick: true,
          cursor: ''
        });
      });

      $('.bold_options').show();

      if ( $(this).hasClass('bold_option_checkbox') ) {
        $inputContainer.find('input').on('change', function(){
          $label.toggleClass('selected');
        });
      } else if ( $(this).hasClass('bold_option_dropdown') ) {
        $inputContainer.insertAfter($helpText);
        $price = $('<span class="bold_option_value_price"></span>').insertAfter($inputContainer);
        
        var $select = $inputContainer.find('select');

        $select.on('change', function() {
          if ( $(this).val() ) {
            $label.addClass('selected');
            var optionText = $select.find('option:selected').text();
            findPrice = optionText.match(/\[(.*?)\]/);

            if (findPrice) {
                var price = findPrice[1];
            }
            $price.text(price);
          } else {
            $label.removeClass('selected');
            $price.text('');
          }
        })
      }
      
    });
  }

  $(document).on('ready', function(){
    setTimeout(function(){
      setupUpgrades();
    }, 1000);
  });
}

//not on a safety sleeper product
else {
  //show the gallery
  $(".product-gallery--media-thumbnail").show();
}

  // All pages/products
  $(".product-options .inline-field-wrapper input").change(function() {
    var $parentFieldWrapper = $(this).parents('.inline-field-wrapper');
    var newValue = $parentFieldWrapper.find('input:checked').val();
    $parentFieldWrapper.find('.input-field-selected').text(newValue);
  });
});

//back to top scroller
$(document).ready(function(){ 
    $(window).scroll(function(){ 
        if ($(this).scrollTop() > 100) { 
            $('#scroll').fadeIn(); 
        } else { 
            $('#scroll').fadeOut(); 
        } 
    }); 
    $('#scroll').click(function(){ 
        $("html, body").animate({ scrollTop: 0 }, 600); 
        return false; 
    }); 
});

//Form submission message

a= window.location.href;

if (a.indexOf("customer_posted=true") > 0){
    console.log('true')

    $("#submissionReceived").prepend("Your submission has been successfully received!").show();
} 

$("#submissionReceived-close").click(function(){
    $("#submissionReceived").hide();                               
});

  // Popup functionality
  $(document).ready(function(){

    popupCookie = getCookie('tssPopup');
    
    if (popupCookie === 'true') {
      $('#tss-popup').hide();
      return false;
    } else {
    
      // After a set amount of time, the popup appears
      setTimeout(function(){
        $('#tss-popup').addClass('visible');
      }, 3000);
    }
    
    // Clicking the close button hides the popup and assigns a cookie to the user to keep the popup from showing again for 1 week
    $('.popup .close, .popup .button').on('click', function(){
      setCookie('tssPopup', 'true', 7);
      var $popup = $(this).parent('.popup');
      $popup.addClass('dismissed');
      setTimeout(function(){
        $popup.hide();
      }, 500);
    });
  });

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}


//localization


$(document).ready(function(){
                            

var country = localStorage.getItem('ss_country');

console.log("country",country);

if (country == null){
                     
    var d = $.get("http://ipinfo.io", function(response) {
        country = response.country ;
        console.log('ci:'+country);
     
    }, "jsonp");

    d.promise().done(function(){
    
    console.log('c:'+country);   
    localStorage.setItem('ss_country',country);
   updateLocalization(country);
                           
    });  
                     }

else {updateLocalization(country);}


});

function updateLocalization(country){
                                     
console.log ('updateLocalization');

console.log ('country',country);


if (country == "US" || country == "CA" )

{
     console.log("User in US or Canada. Showing Region 1 Options");
    $(".region1").addClass("regionShow");
 $(".region2").removeClass("regionShow");
 }

else
{

      console.log("User NOT in US or Canada. Showing Region 2 Options");

 $(".region1").removeClass("regionShow");
 $(".region2").addClass("regionShow");
 
 } 


                                     }





$(".request-quote").click(function(){
    $("#requestQuoteForm").html("");
console.log('request-quote clicked');

//generate jotform url 

var baseformurl = 'https://form.jotform.com/203446486012148?';

if ($(".product-title").text().indexOf('200') >= 0)
    {
    var model = "200 (standard-single side door)"
    }

    else if ($(".product-title").text().indexOf('300') >= 0)
        {
        var model = "300 (Side and end of bed doors)"
        }

    else if ($(".product-title").text().indexOf('400') >= 0)
        {
        var model = "400 (dual side entry + convertible top)"
        }

console.log('model',model);

var size = $("[name='option-0']:checked").val();





var color = $("[name='option-1']:checked").val();

var url = baseformurl + "bedSize="+size+"&bedColor="+color+"&bedModel="+model;
console.log('url',url)



$("#requestQuoteForm").html("<iframe src='"+url+"'></iframe>");

});




